import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  className?: string;
}

const KlubAdventureIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#FC3B26",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 96 96"
      fill="none"
    >
      <path
        d="M10.2488 27.8356L11.3255 29.3657L10.2535 30.0193C9.88829 30.2419 9.5663 30.516 9.28769 30.8239L8.10481 29.1428C7.91092 28.8672 7.99372 28.4975 8.28973 28.317L9.36173 27.6634C9.65775 27.4829 10.0549 27.56 10.2488 27.8356Z"
        fill={color}
      />
      <path
        d="M11.4421 37.1118L10.0416 35.1214C9.03815 33.6954 9.54582 31.8683 10.9637 31.0038L21.6547 24.4853C23.1284 23.5868 25.1129 23.9719 26.0781 25.3437L27.4787 27.3341C28.4439 28.7059 28.0302 30.5531 26.5565 31.4517L24.4183 32.7554C22.9446 33.6539 21.6822 34.295 20.717 32.9232C20.5238 32.6486 20.1272 32.5717 19.8323 32.7515C19.5374 32.9313 19.4547 33.3005 19.6479 33.575C20.154 34.4297 19.9632 35.2838 19.3212 35.7667C18.6429 36.2768 18.7257 36.2263 18.0037 36.6665L15.8655 37.9702C15.3936 38.2579 14.8485 38.4236 14.2901 38.4495C13.1358 38.5054 12.0709 38.0054 11.4421 37.1118Z"
        fill={color}
      />
      <path
        d="M21.0956 37.5998C20.8001 37.78 20.4044 37.7032 20.2109 37.4282C20.0174 37.1531 20.0999 36.7848 20.3953 36.6047C20.5564 36.5064 23.4715 34.7291 23.3596 34.7973C23.655 34.6172 24.0507 34.6939 24.2442 34.969C24.4378 35.244 24.3553 35.6124 24.0598 35.7925L23.6465 36.0445L24.7202 37.5705C25.3778 38.5049 25.6016 39.6129 25.3482 40.6999C25.0812 41.9428 24.2294 42.9873 22.9798 43.5771C20.9215 44.5487 18.392 43.7755 17.1275 41.9785L15.4625 39.6123L17.6007 38.3086L19.3747 40.8297C19.9539 41.6529 21.1445 41.8839 22.0288 41.3448C22.9131 40.8056 23.1612 39.6973 22.582 38.8742L21.5083 37.3482L21.0956 37.5998Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78 24C72.486 24 68 28.486 68 34C68 39.514 72.486 44 78 44C83.514 44 88 39.514 88 34C88 28.486 83.514 24 78 24ZM81.1422 26.3382L78.8657 27.5623V29.6696L82.1642 32.0724L83.8367 31.2527L84.3837 28.7273C83.5219 27.686 82.4102 26.8606 81.1422 26.3382ZM71.6296 28.7095C72.4936 27.6708 73.6075 26.8497 74.878 26.3308L77.1551 27.5596V29.6697L73.8587 32.0725L72.1768 31.2513L71.6296 28.7095ZM73.5644 38.718L71.1007 38.5816C70.3849 37.5074 69.913 36.2594 69.7646 34.9142L71.6291 32.8889L73.256 33.6844L74.5939 37.4842L73.5644 38.718ZM81.0682 39.7278L79.9994 42.0337C79.3558 42.1953 78.6888 42.2882 78 42.2882C77.1611 42.2882 76.352 42.16 75.5876 41.9267L74.9011 39.7899L75.9635 38.5135H80.0424L81.0682 39.7278ZM85.1842 38.1105L82.4033 38.6595L81.4093 37.4826L82.7655 33.6846L84.3839 32.8917L86.2366 34.915C86.1091 36.0675 85.739 37.1464 85.1842 38.1105Z"
        fill={color}
      />
      <path
        d="M50.7169 9.85203C49.4214 7.38266 46.5661 7.38266 45.2707 9.85203L42.7224 14.7096C42.4589 15.2119 42.4815 15.8732 42.7782 16.3446L44.96 19.8105C45.1539 20.1184 45.4417 20.3069 45.7516 20.3287C46.0614 20.3505 46.3639 20.2036 46.5833 19.9247L47.5953 18.6387L50.034 23.2636C50.1805 23.7289 50.513 24.0574 50.9039 24.1231C51.2948 24.1889 51.6831 23.9815 51.9197 23.5805L54.321 18.3899C54.5985 17.9198 54.6125 17.2782 54.356 16.7891L50.7169 9.85203Z"
        fill={color}
      />
      <path
        d="M59.8168 26.0626L55.3804 18.4609C55.3294 18.612 55.2651 18.7584 55.1874 18.8976L52.783 24.0948L52.7559 24.1408C52.3419 24.8426 51.5888 25.304 50.75 25.163C49.9665 25.0313 49.3934 24.4223 49.1334 23.7044L47.4341 20.4817L47.3403 20.6009C46.9417 21.1075 46.3449 21.4254 45.6866 21.3791C45.0312 21.3331 44.4807 20.9384 44.1398 20.397L41.958 16.9312C41.8765 16.8018 41.8073 16.6652 41.7504 16.5235L36.1832 26.0626C35.9601 26.445 35.9392 26.9367 36.1291 27.3419C36.3189 27.7472 36.6886 28 37.0909 28H58.9091C59.3114 28 59.6811 27.7472 59.8709 27.3419C60.0608 26.9367 60.0399 26.445 59.8168 26.0626Z"
        fill={color}
      />
      <path
        d="M60.3776 48.3588C60.3776 55.184 54.942 60.717 48.2369 60.717C41.5317 60.717 36.0962 55.184 36.0962 48.3588C36.0962 41.5335 41.5317 36.0005 48.2369 36.0005C54.942 36.0005 60.3776 41.5335 60.3776 48.3588Z"
        fill={color}
      />
      <path
        d="M30.2984 67.1242C31.2764 65.5849 32.8795 64.7053 34.5495 64.6072L34.5493 64.6022H34.6524C34.7924 64.5967 34.9328 64.5966 35.0732 64.6022H60.9889C61.0882 64.5994 61.1874 64.5994 61.2865 64.6022H61.3386C63.0488 64.6665 64.7022 65.5524 65.7021 67.1263L73.3586 79.1768C73.6601 79.6513 73.8883 80.1702 74.0353 80.7152L76 88.0005H64.9847C64.6761 83.6736 61.8468 80.3776 60.5696 79.5108L60.0642 88.0005H35.7939L35.2884 79.5108C34.0112 80.3776 31.1819 83.6736 30.8733 88.0005H20L21.9652 80.7131C22.1122 80.1681 22.3405 79.6493 22.642 79.1747L30.2984 67.1242Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubAdventureIcon;
